import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';

export enum OrderTabs {
  Overview = 'Overview',
  Comments = 'Comments',
  Tasks = 'Tasks',
  Documents = 'Documents',
  Fees = 'Fees',
  Contacts = 'Contacts',
  Escrow = 'Escrow',
  Activity = 'Activity',
  Title = 'Title',
  Scheduling = 'Scheduling',
  Workflow = 'Workflows',
  Inbox = 'Inbox'
}

export interface IOrderNavigationSlice {
  tab?: OrderTabs;
  title?: string;
  lastBreadcrumb?: string;
}

export const orderNavigationSlice = createSlice<
  IOrderNavigationSlice,
  SliceCaseReducers<IOrderNavigationSlice>,
  string
>({
  name: 'orderNavigationSlice',
  initialState: {
    tab: undefined,
    title: undefined,
    lastBreadcrumb: undefined,
  },
  reducers: {
    setup: (state, action: PayloadAction<IOrderNavigationSlice>) => {
      state.tab = action.payload.tab;
      state.lastBreadcrumb = action.payload.lastBreadcrumb;
      state.title = action.payload.title;
    },
  },
});
